No: 否
Yes: 是
RefuseGiftCard: 要拒收礼品卡吗?
useGiftCardTitle: 如何使用礼品卡?
useGiftCardDesc: 领取礼品卡后，您可查看可用商家。手机下单时，可选礼品卡支付。柜台结账时，可报电话号码用礼品卡付款。
ReceivedSuccess: 领取成功
RefusedSuccess: 拒绝成功
requestFail: '网络连接异常 {0}'
